import { FC, ReactNode, Suspense } from "react"

import { PageLoader } from "@/components/_Shared/PageLoader"

interface WithSuspenseProps {
  children: ReactNode
}

export const WithSuspense: FC<WithSuspenseProps> = ({ children }) => <Suspense fallback={<PageLoader />}>{children}</Suspense>
